module.exports = __webpack_public_path__ + "static/media/Women drinking whisky at a bar-0833 (credit OurWhisky Foundation_Jo Hanley).07820e62.jpg";